// Replace Expivi "Add to Cart" with "Request Quote" button
document.addEventListener('DOMContentLoaded', function () {
  function replaceExpiviButton() {
    const originalBtn   = document.querySelector('.btn.expivi-add-to-cart');
    const bottomContent = document.querySelector('.bottom-content');

    if (!originalBtn || !bottomContent) {
      // Wait until Expivi renders the button
      setTimeout(replaceExpiviButton, 300);
      return;
    }

    // Create the new button
    const rfqBtn = document.createElement('button');
    rfqBtn.type = 'button';
    rfqBtn.className = 'btn expivi-rfq';
    rfqBtn.textContent = 'Request Quote';

    // Replace the original Add to Cart button
    originalBtn.replaceWith(rfqBtn);

    console.log('✅ Replaced Expivi "Add to Cart" with "Request Quote" button');
  }

  replaceExpiviButton();
});


// ===============================
//  SAVE MODAL + EMAIL VALIDATION
// ===============================
function initExpiviSaveModal() {
  // RFQ trigger button
  const saveBtn       = document.querySelector('.btn.expivi-rfq');

  const modal         = document.getElementById('save-modal-wrapper');
  const attributeList = document.getElementById('saveModalAttributes');
  const cancelBtn     = document.getElementById('cancelSaveModal');
  const closeBtn      = document.getElementById('closeSaveModal');
  const confirmBtn    = document.getElementById('confirmSaveModal');

  // Inputs
  const nameInput = document.getElementById('saveModalName');
  const orgInput  = document.getElementById('saveModalOrganization');
  const phoneInput= document.getElementById('saveModalPhone');
  const emailInput= document.getElementById('saveModalEmail');
  const hiddenUrl = document.getElementById('saveModalPageUrl');

  // ✅ Do NOT require thumbnails to exist to initialize
  if (!saveBtn || !modal || !attributeList || !emailInput || !nameInput || !confirmBtn) {
    setTimeout(initExpiviSaveModal, 300);
    return;
  }

  // Helpers
  const EMAIL_RE = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
  const isValidEmail = (email) => EMAIL_RE.test(email.trim());

  emailInput.setAttribute('type', 'email');
  emailInput.setAttribute('pattern', EMAIL_RE.source);

  function resetConfirmButton() {
    confirmBtn.disabled = false;
    confirmBtn.innerHTML = 'Send quote request';
  }

  function closeModal() {
    modal.classList.remove('show');
    modal.classList.add('hide');
    setTimeout(() => {
      modal.style.display = 'none';
      modal.classList.remove('hide');
      resetConfirmButton();
    }, 300);
  }

  modal.addEventListener('click', (e) => {
    if (e.target === modal) closeModal();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.style.display === 'flex') closeModal();
  });

  // -----------------------------
  //  SCREENSHOTS + CONFIG CAPTURE
  // -----------------------------
  window.handleMoonaSaveClick = async function () {
    console.log('🧠 handleMoonaSaveClick triggered');

    if (typeof expivi?.saveConfiguration !== 'function') {
      alert('Expivi is not ready yet.');
      return;
    }

    try {
      const delay = (ms) => new Promise((r) => setTimeout(r, ms));

      // Save configuration
      const configJson = await expivi.saveConfiguration(0, 0);

      // Screenshots
      const frontScreenshot = await expivi.getScreenshot(720, 720, 'FIT_OBJECT_FRONT', 'image/jpeg');
      await delay(500);
      const backScreenshot  = await expivi.getScreenshot(720, 720, 'FIT_OBJECT_BACK',  'image/jpeg');

      // Clean base64
      const cleanBase64 = (s) => (s || '').replace(/^data:image\/jpeg;base64,/, '').trim();
      const frontBase64 = cleanBase64(frontScreenshot);
      const backBase64  = cleanBase64(backScreenshot);

      // Add preview-only thumbnails
      configJson.thumbnail_front = frontScreenshot;
      configJson.thumbnail_back  = backScreenshot;
      configJson.thumbnail       = frontScreenshot;

      // Keep for submit
      window._latestConfigJson  = configJson;
      window._latestScreenshots = { front: frontBase64, back: backBase64 };

      // Clean URL for payload
      const url = new URL(window.location.href);
      url.searchParams.delete('configuration');
      if (hiddenUrl) hiddenUrl.value = url.toString();

      // Show modal
      window.showSaveModal(configJson);
    } catch (err) {
      console.error('❌ Error saving configuration or capturing screenshots:', err);
      alert('An error occurred while generating screenshots.');
    }
  };

  // Bind actions
  saveBtn.addEventListener('click', window.handleMoonaSaveClick);
  cancelBtn.onclick = closeModal;
  closeBtn.onclick  = closeModal;

  // -----------------------------
  //  SUBMIT TO MAKE.COM
  // -----------------------------
  confirmBtn.onclick = () => {
    const fullName    = (nameInput.value || '').trim();
    const organization= (orgInput?.value || '').trim();
    const phone       = (phoneInput?.value || '').trim();
    const email       = (emailInput.value || '').trim();
    const configJson  = window._latestConfigJson;

    if (!fullName) { alert('Please enter your full name.'); nameInput.focus(); return; }
    if (!email)    { alert('Please enter your email address.'); emailInput.focus(); return; }
    if (!isValidEmail(email)) { alert('Please enter a valid email address.'); emailInput.focus(); return; }
    if (!configJson) { alert('Configuration data is missing.'); return; }

    // Disable button & show spinner
    confirmBtn.disabled = true;
    confirmBtn.innerHTML = `
      <span class="spinner" style="
        border: 2px solid #fff;
        border-top: 2px solid transparent;
        border-radius: 50%;
        width: 14px;
        height: 14px;
        display: inline-block;
        margin-right: 8px;
        animation: spin 0.6s linear infinite;
        vertical-align: middle;"></span> Sending...`;

    // Safe copy of configuration
    const configCopy = JSON.parse(JSON.stringify(configJson));
    const { front, back } = window._latestScreenshots || {};

    // Build HTML summary of attributes & selected options
    let htmlLines = '<div class="configuration-line-items"><b>Configuration details</b><br><br>';
    if (Array.isArray(configCopy.configured_products)) {
      configCopy.configured_products.forEach(prod => {
        const attrs = Array.isArray(prod?.configuration?.attributes)
          ? prod.configuration.attributes
          : Array.isArray(prod?.attributes) ? prod.attributes : [];
        // Skip list (case-sensitive matches on attribute_name)
        const SKIP_ATTRIBUTE_NAMES = new Set([
          /*'Front Number input 01',
          'Front Number input 02',
          'Player name input 01',
          'Player name input 02',
          'Back Number input 01',
          'Back Number input 02',
          'Team logo input 01',
          'Team logo input 02',
          'Pants front number input 01',
          'Pants front number input 02',
          'Pants back number input 01',
          'Pants back number input 02',
          'Jersey Pinstripe Element selector',
          'Jersey Team Logo Element selector',
          'Jersey Trim1 Element selector',
          'Jersey Trim2 Element selector',
          'NeckPiping 01 Element selector',
          'NeckPiping 02 Element selector',
          'NeckPiping 03 Element selector',
          'SleevePiping 03 Element selector',
          'SleevePiping 01 Element selector',
          'SleevePiping 02 Element selector',
          'Jersey Front number element selector',
          'Jersey Front number trim 1 element selector',
          'Jersey Front number trim 2 element selector',
          'Jersey Back number element selector',
          'Jersey Back number trim 1 element selector',
          'Jersey Back number trim 2 element selector',
          'Player name back element selector',
          'Player name trim 1 element selector',
          'Player name trim 2 element selector',
          'Left sleeve logo element selector',
          'Right sleeve logo element selector',
          'Back of neck logo element selector',
          'Pants pinstripes element selector',
          'PantPiping 01 element selector',
          'PantPiping 02 element selector',
          'PantPiping 03 element selector',
          'Pant number base element selector',
          'Pant number trim 01 selector',
          'Pant number trim 02 selector',
          'Add a logo to the pants element selector',
          'Pants_DynamicPattern',
          'Toggle camera',
          'Collar type',
          'Camera positions'*/
        ]);

        attrs.forEach(attr => {
          const name = attr?.attribute_name;
          const val  = attr?.attribute_value_name;

          if (!name || !val) return;
          if (SKIP_ATTRIBUTE_NAMES.has(name)) return;

          htmlLines += `<b>${name}:</b> ${val}<br>`;
        });
      });
    }
    htmlLines += '</div>';

    // Collect all unique print_ready_file_id values (across all configured products)
    const prfIds = getPrintReadyFileIds(configCopy);

    // Remove preview-only images before sending
    delete configCopy.thumbnail_front;
    delete configCopy.thumbnail_back;
    delete configCopy.thumbnail;

    // Payload to Make.com
    const payload = {
      name: fullName,
      organization,
      phone,
      email,
      page_url: hiddenUrl ? hiddenUrl.value : window.location.href,
      configuration: configCopy,
      screenshot_front: front || '',
      screenshot_back:  back || '',
      'configuration-line-items': htmlLines,
      print_ready_file_ids: prfIds // ← NEW
    };

    fetch('https://hook.eu2.make.com/vp1ijmu3jb8hu9wer4aiemvvf5oqd80c', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(response => {
        console.log('📤 Sent to Make.com:', response.status);
        setTimeout(() => {
          confirmBtn.innerHTML = 'Request sent!';
          setTimeout(() => { closeModal(); }, 3000);
        }, 1000);
      })
      .catch(error => {
        console.error('❌ Error sending to Make.com:', error);
        resetConfirmButton();
      });
  };

  // -----------------------------
  //  RENDER MODAL PREVIEW
  // -----------------------------
  window.showSaveModal = function (configJson) {
    const attributes = Array.isArray(configJson.attributes) ? configJson.attributes : [];

    const imgFront = document.getElementById('saveModalThumbnailFront');
    const imgBack  = document.getElementById('saveModalThumbnailBack');

    if (imgFront) {
      if (configJson.thumbnail_front) { imgFront.style.display = 'block'; imgFront.src = configJson.thumbnail_front; }
      else { imgFront.style.display = 'none'; }
    }

    if (imgBack) {
      if (configJson.thumbnail_back) { imgBack.style.display = 'block'; imgBack.src = configJson.thumbnail_back; }
      else { imgBack.style.display = 'none'; }
    }

    attributeList.innerHTML = attributes
      .map(attr => `<li><strong>${attr.attribute_name}:</strong> ${attr.attribute_value_name}</li>`)
      .join('');

    modal.classList.add('show');
    modal.style.display = 'flex';
    resetConfirmButton();
  };
}


// ==================================
//  UTIL: COLLECT UNIQUE PRF ID LIST
// ==================================
function collectAllAttributes(conf) {
  const out = [];
  const cps = Array.isArray(conf?.configured_products) ? conf.configured_products : [];
  cps.forEach(cp => {
    if (Array.isArray(cp.attributes)) out.push(...cp.attributes);
    if (Array.isArray(cp?.configuration?.attributes)) out.push(...cp.configuration.attributes);
  });
  return out;
}

function getPrintReadyFileIds(conf) {
  const ids = new Set();
  collectAllAttributes(conf).forEach(attr => {
    const id = attr?.attribute_value?.print_ready_file_id;
    if (id) ids.add(id);
  });
  return [...ids];
}


// Spinner animation CSS (injected)
const style = document.createElement('style');
style.innerHTML = `
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}`;
document.head.appendChild(style);

// Kick off modal init slightly delayed
setTimeout(initExpiviSaveModal, 500);



// expivi AR button tooltip (fixed position, caret, no mouse-follow)
document.addEventListener('DOMContentLoaded', function () {
  if (!window.expivi || !window.expivi._events?.onChange) return;

  window.expivi._events.onChange.subscribe(function (e) {
    if (e.name !== 'fully_loaded') return;

    const btn = document.querySelector('#xpv-toolbar-item-web-ar');
    if (!btn || btn.dataset.tooltipBound) return; // prevent double-binding
    btn.dataset.tooltipBound = '1';

    // Replace icon + add label (kept from your current code)
    btn.querySelector('svg')?.remove();
    btn.insertAdjacentHTML('afterbegin', `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none"
           stroke="#000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M12.6 4L16 2l3.4 2M16 2v5m3.4 21L16 30l-3.4-2M16 30v-5M4 13V9l3.3-2M4 9l4.2 2.5M28 19v4l-3.3 2M28 23l-4.2-2.5M7.3 25L4 23v-4M4 23l4.2-2.5M24.7 7L28 9v4M28 9l-4.2 2.5M16 20v-4l3.4-2M16 16l-3.4-2"/>
      </svg>
      <span>AR</span>
    `);

    // Create tooltip element once
    const tip = document.createElement('div');
    tip.className = 'xpv-ar-tooltip xpv-ar-tooltip--fixed';
    tip.setAttribute('role', 'tooltip');
    tip.textContent = 'View in Augmented Reality';
    document.body.appendChild(tip);

    // Positioning (centered above the button, with offset for caret)
    const positionTooltip = () => {
      const rect = btn.getBoundingClientRect();
      const scrollX = window.pageXOffset || document.documentElement.scrollLeft;
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;

      // First make it visible offscreen to measure width/height
      tip.style.visibility = 'hidden';
      tip.style.display = 'block';

      const tw = tip.offsetWidth;
      const th = tip.offsetHeight;
      const caret = 8; // keep in sync with CSS --caret-size

      const left = rect.left + scrollX + rect.width / 2 - tw / 2;
      const top  = rect.top  + scrollY - th - caret;

      tip.style.left = `${Math.max(8, left)}px`; // clamp a bit from viewport edges
      tip.style.top  = `${Math.max(8, top)}px`;

      tip.style.visibility = '';
    };

    // Show/hide handlers (hover + focus for accessibility)
    const show = () => {
      positionTooltip();
      tip.classList.add('is-visible');
      // Keep it anchored on resize/scroll (but not mousemove)
      window.addEventListener('scroll', positionTooltip, { passive: true });
      window.addEventListener('resize', positionTooltip);
    };
    const hide = () => {
      tip.classList.remove('is-visible');
      window.removeEventListener('scroll', positionTooltip);
      window.removeEventListener('resize', positionTooltip);
    };

    btn.addEventListener('mouseenter', show);
    btn.addEventListener('mouseleave', hide);
    btn.addEventListener('focusin', show);
    btn.addEventListener('focusout', hide);
  });
  
});


document.addEventListener('DOMContentLoaded', function () {

  window.expivi._events.onChange.subscribe(function (e) {
    if (e.name !== "fully_loaded") return;

    /* ---------------------------
      1) Camera buttons UI (mount OUTSIDE Expivi render tree)
    ---------------------------- */
    if (!document.querySelector('.xpv-camera-controls')) {
      const cameraContainer = document.createElement('div');
      cameraContainer.className = 'xpv-camera-controls';

      const cameraViews = [
        { label: 'Front', value: 'att-camera-front' },
        { label: 'Left',  value: 'att-camera-left' },
        { label: 'Back',  value: 'att-camera-back' },
        { label: 'Right', value: 'att-camera-right' }
      ];

      cameraViews.forEach(view => {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'xpv-camera-btn';

        btn.innerHTML = `
          <span class="xpv-camera-icon">
            <img src="https://cdn.shopify.com/s/files/1/0558/1668/3728/t/38/assets/camera_icon.svg" alt="${view.label}">
          </span>
          <span class="xpv-camera-label">${view.label}</span>
        `;

        btn.addEventListener('click', () => {
          window.expivi.setProductAttributeByKey('att-camera', view.value);
        });

        cameraContainer.appendChild(btn);
      });

      const expiviViewer = document.getElementById('expivi-viewer-container');
      const stableParent = expiviViewer?.parentElement; // ✅ stable, not re-rendered by Expivi

      if (stableParent) {
        stableParent.appendChild(cameraContainer);
      } else if (expiviViewer) {
        // fallback: if no parent found, still mount to viewer
        expiviViewer.appendChild(cameraContainer);
      }
    }

    /* ---------------------------
      2) Attribute sync logic
    ---------------------------- */
    if (!window.__xpvAttributeSyncBound) {
      window.__xpvAttributeSyncBound = true;

      window.expivi._events.onChange.subscribe(async (event) => {
        if (event.name !== 'attribute') return;

        const a   = event.payload;
        const key = a?.attribute_key;
        if (!key) return;

        const textValue = a.attribute_value_name;
        const fontValue = a.attribute_value?.font;

        if (!textValue) return;

        // =====================================================
        // SPECIAL CASE:
        // front-number-input-base controls ALL number fields
        // =====================================================
        if (key === 'front-number-input-base') {
          // 1) front-number-input-2 & 3 → text + font
          if (fontValue) {
            await window.expivi.setProductAttributeByKey('front-number-input-2', {
              text: textValue,
              font: fontValue
            });

            await window.expivi.setProductAttributeByKey('front-number-input-3', {
              text: textValue,
              font: fontValue
            });
          } else {
            await window.expivi.setProductAttributeByKey('front-number-input-2', {
              text: textValue
            });

            await window.expivi.setProductAttributeByKey('front-number-input-3', {
              text: textValue
            });
          }

          // 2) All other number-related fields → text ONLY
          const textOnlyTargets = [
            'back-number-input-base',
            'back-number-input-2',
            'back-number-input-3',

            'pants-front-number-input-base',
            'pants-front-number-input-2',
            'pants-front-number-input-3',

            'pants-back-number-input-base',
            'pants-back-number-input-2',
            'pants-back-number-input-3'
          ];

          for (const targetKey of textOnlyTargets) {
            await window.expivi.setProductAttributeByKey(targetKey, {
              text: textValue
            });
          }

          return;
        }

        // =====================================================
        // GENERIC BASE → 2 / 3 SYNC (text + font)
        // =====================================================
        if (!fontValue) return;

        const syncMap = {
          'team-logo-input-base': [
            'team-logo-input-2',
            'team-logo-input-3'
          ],
          'back-number-input-base': [
            'back-number-input-2',
            'back-number-input-3'
          ],
          'player-name-input-base': [
            'player-name-input-2',
            'player-name-input-3'
          ],
          'pants-front-number-input-base': [
            'pants-front-number-input-2',
            'pants-front-number-input-3'
          ],
          'pants-back-number-input-base': [
            'pants-back-number-input-2',
            'pants-back-number-input-3'
          ]
        };

        if (!syncMap[key]) return;

        for (const targetKey of syncMap[key]) {
          await window.expivi.setProductAttributeByKey(targetKey, {
            text: textValue,
            font: fontValue
          });
        }
      });
    }


  });

});

